"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCooperativeProductsSummaryStreamResponse = exports.getCooperativeProductsSummaryStream = void 0;
const ndjson_1 = require("ndjson");
const routes_1 = require("../../routes");
const getCooperativeProductsSummaryStream = (client) => async () => {
    const response = await (0, exports.getCooperativeProductsSummaryStreamResponse)(client)();
    return response.data.pipe((0, ndjson_1.parse)());
};
exports.getCooperativeProductsSummaryStream = getCooperativeProductsSummaryStream;
const getCooperativeProductsSummaryStreamResponse = (client) => async () => {
    const response = await client.get(routes_1.ENDPOINTS.GET_PRODUCTS_SUMMARY.path, {
        headers: {
            accept: 'application/x-ndjson',
        },
        responseType: 'stream',
    });
    return response;
};
exports.getCooperativeProductsSummaryStreamResponse = getCooperativeProductsSummaryStreamResponse;
